import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import checkmarkCreateProject from "../../../assets/images/checkmarkCreateProject";
// import { usePlacesWidget } from "react-google-autocomplete";
import Autocomplete from "react-google-autocomplete";
import { placements } from "@popperjs/core";

class LocationComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      minimize: this.props.minimize,
      autocomplete: null,
      input_text: "",
    }

    this.editPlace = this.editPlace.bind(this)
  }


  componentDidMount() {
  }


  // handleInput(field) {
  //   return e => {
  //     if (field === "zipcode" && e.currentTarget.value.length > 5){
  //       this.props.changeParentState({ [field]: e.currentTarget.value.slice(0, 5)})
  //     } else {
  //     this.props.changeParentState({ [field]: e.currentTarget.value })
  //     }
  //   }
  // }

  handleInput(field){
    return e => {
      if (field === "input_text"){
        if (this.props.city){
          this.props.changeParentState({ street: "", city: "", state: "", zip_code: "", latitude: "", longitude: "", formatted_address: "", county: ""})
          this.setState({ [field]: "" })
        } else {
        this.setState({[field]: e.currentTarget.value})
        }
      } else {
        this.props.changeParentState({ [field]: e.currentTarget.value })
      }
    }
  }

  editPlace(place, inputText){

    let latitude = place.geometry.location.lat();
    let longitude = place.geometry.location.lng();

    let formatted_address = place.formatted_address.split(",").slice(0, place.formatted_address.split(",").length - 1).join(",")

    const getComponent = (type) =>
      place.address_components.find(c => c.types && c.types.includes(type))?.long_name || "";

    let street_number = getComponent("street_number");
    const address = getComponent("route");
    const city = getComponent("sublocality_level_1") || getComponent("neighborhood")  || getComponent("locality") || getComponent("administrative_area_level_3");
    const zip_code = getComponent("postal_code");
    const county = getComponent("administrative_area_level_2");
    const state = place.address_components.find(c => c.types && c.types.includes("administrative_area_level_1"))?.short_name || "";

    let street;
    if (street_number === "" && address === "") {
      // Named building or premise with no street number/name (e.g. "The Rivermere")
      street = getComponent("premise") || getComponent("establishment") || place.name || inputText.split(",")[0].trim();
    } else {
      if (street_number === "") {
        street_number = inputText.split(" ")[0];
      }
      street = `${street_number} ${address}`.trim();
    }

    const result = this.props.changeParentState({formatted_address: formatted_address, street: street, apartment: "", city: city, state: state, zipcode: zip_code, latitude: latitude, longitude: longitude, county: county})
    if (this.props.onAddressSelected) {
      Promise.resolve(result).then(() => this.props.onAddressSelected())
    }
  }

  render() {

    let streetErrorClass = "";
    let apartmentErrorClass = "";
    let cityErrorClass = "";
    let stateErrorClass = "";
    let zipcodeErrorClass = "";

    let streetErrors = [];
    let apartmentErrors = [];
    let cityErrors = [];
    let stateErrors = [];
    let zipcodeErrors = [];

    (this.props.errors || []).forEach((error) => {

      if (error[0] === 1) {
        streetErrors.push(<li>{error[1]}</li>)
        streetErrorClass = "formInputError"
      }

      else if (error[0] === 2) {
        cityErrors.push(<li>{error[1]}</li>)
        cityErrorClass = "formInputError"
      }
      else if (error[0] === 3) {
        stateErrors.push(<li>{error[1]}</li>)
        stateErrorClass = "formInputError"
      }
      else if (error[0] === 4) {
        zipcodeErrors.push(<li>{error[1]}</li>)
        zipcodeErrorClass = "formInputError"
      }
      else if (error[0] === 0) {
        backendErrors.push(<li>{error[1]}</li>)
      }

    })


    let icon = <div key="1"><i className="fas fa-window-minimize"></i></div>
    let minimizeId = ""
    let minimized = ""
    let checkmark =""

    if (this.state.minimize){
      icon = <div key="2"><i className="fas fa-plus"></i></div>
      minimizeId = "hidePropertyInputs"
      minimized = "projectHeadingMinmizedView"

      if (this.props.page && this.props.page > 1){
        checkmark = "createProjectCheckmarkShow"
      }

    }

    if (this.props.inComponent){
      return (
      <div>
        {this.props.virtual_staging_homepage ? "" : <div className="settingsComponentHeading">{this.props.title || 'Property Location'}</div>}
          <div className={this.props.settings_location_prices ? "" : "inputGrouping topGrouping"} id={minimizeId}>
            <div className={this.props.settings_location_prices ? "" : "propertyLocationInput1"}>
              {!this.props.settings_location_prices && <label id="formLabel"> Property Address </label>}
              <Autocomplete className="formInput"
                onPlaceSelected={(place) => {
                  this.editPlace(place, this.state.input_text)
                }}
                id={streetErrorClass}
                options={{ types: ["address"] }}
                value={this.props.formatted_address ? this.props.formatted_address : this.state.input_text}
                onChange={this.handleInput("input_text")}
              />
              {/* <input className="formInput" id={streetErrorClass} onChange={this.handleInput("street")} type="string" placeholder="Street" value={this.props.street} /> */}
              <ul className="errorUl" id={minimizeId}>{streetErrors}</ul>
            </div>
            {/* <Autocomplete
            onPlaceSelected={(place) => {
              this.editPlace(place)
            }}
            options={{types: ["address"] }}
          />; */}
            {this.props.virtual_staging_homepage ? "" : <div className="propertyLocationInput2">
              <label id="formLabel"> Apartment </label>
              <input className="formInput" id={apartmentErrorClass} onChange={this.handleInput("apartment")} type="string" placeholder="Not Required" value={this.props.apartment} />
              <ul className="errorUl" id={minimizeId}>{apartmentErrors}</ul>
            </div>}
         </div>
       </div>
      )
    } else {
      return (
        <div className="projectLocationComponent realProjectLocationComponent" id={this.props.createProjectLoggedIn ? "createProjectLocationComponent" : ""}>
          <div className="projectLocationHeadingGrouping modalHeader" id={minimized}>
            <div className="projectLocationHeadingMinimizedGrouping">
              <div className="createProjectCheckmark" id={checkmark}><img src={checkmarkCreateProject}/></div>
              <div className="settingsComponentHeading">{this.props.title || 'Property Location'}</div>
              {this.props.coupon?.id && <div className="couponAppliedBadge">
                {this.props.coupon.percentage ? `${this.props.coupon.amount}% discount applied` : `$${this.props.coupon.amount} discount applied`}
              </div>}
            </div>
            {/* <div className="minimizeButton" onClick={() => this.setState({ minimize: !this.state.minimize })}>{icon}</div> */}
          </div>
          {/* <div className="subServicesHeadingBottomDivider" id={minimizeId}/> */}
          <div className="inputGrouping topGrouping" id={minimizeId}>
            <div className="propertyLocationInput1">
              <label id="formLabel"> {this.props.homepageModal ? "Enter Address to View Services & Pricing" : "Address"} </label>
              <Autocomplete className="formInput"
                onPlaceSelected={(place) => {
                  this.editPlace(place, this.state.input_text)
                }}
                id={streetErrorClass}
                options={{ types: ["address"] }}
                value={this.props.formatted_address ? this.props.formatted_address : this.state.input_text}
                onChange={this.handleInput("input_text")}
              />
              {/* <input className="formInput" id={streetErrorClass} onChange={this.handleInput("street")} type="string" placeholder="Street" value={this.props.street} /> */}
              <ul className="errorUl" id={minimizeId}>{streetErrors}</ul>
            </div>
            <div className="propertyLocationInput2">
              <label id="formLabel"> Apartment </label>
              <input className="formInput" id={apartmentErrorClass} onChange={this.handleInput("apartment")} type="string" placeholder="Not Required" value={this.props.apartment} />
              <ul className="errorUl" id={minimizeId}>{apartmentErrors}</ul>
            </div>
          </div>
          {this.props.mapPreview}
        </div>
      )
   }
 } 
}

export default withRouter(LocationComponent);
